@if (isMeasureUser == true) {
  <div class="content-dashboard">
    @if (isDashboard) {
      <div class="content-block-dashboard">
        <abc-dashboard
          class="abc-dasboard-style"
          [endPoint]="dashboardEndpoint"
          [ajaxHeaders]="dashboardAjaxHeader"
          [initialDashboardId]="dashboardId"
        >
        </abc-dashboard>
      </div>
    } @else {
      <h2 fxLayout="row" fxLayoutAlign="center end">{{ title }}</h2>
    }
  </div>
}
@if (isMeasureUser == false) {
  <div class="content-style-class">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column">
        <h2 class="title-style">{{ this.dataService.res('Ubt-Dashboard-Title') }}</h2>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings card-radius">
        <dx-tab-panel [dataSource]="tabs" [selectedIndex]="0" [animationEnabled]="true">
          <div *dxTemplate="let tab of 'title'">{{ tab.title }}</div>

          <div *dxTemplate="let tab of 'item'">
            <ng-container [ngSwitch]="tab.id">
              <ng-container *ngSwitchCase="1">
                <div class="scrollable">
                  <div class="filters-bar">
                    <div class="filter-group">
                      <span class="filter-label">{{ this.dataService.res('Ubt-Dashboard-SubProject') }}</span>
                      <dx-select-box
                        [dataSource]="subProjectOptions"
                        [(value)]="selectedSubProject"
                        displayExpr="name"
                        valueExpr="id"
                        [width]="180"
                        (onValueChanged)="onFilterChanged()"
                      >
                      </dx-select-box>
                    </div>
                    <div class="filter-group">
                      <span class="filter-label">{{ this.dataService.res('Ubt-Dashboard-Status') }}</span>
                      <dx-select-box
                        displayExpr="name"
                        valueExpr="value"
                        [dataSource]="statusOptions"
                        [(value)]="selectedStatus"
                        [width]="160"
                        (onValueChanged)="onFilterChanged()"
                      >
                      </dx-select-box>
                    </div>
                  </div>

                  <!-- MAIN: Matrix + Gauges -->
                  <div class="main-content">
                    <div class="matrix-section">
                      <div class="section-header">{{ this.dataService.res('Ubt-Dashboard-Title-Matrix') }}</div>
                      <div class="matrix-placeholder">
                        <ubt-geods-matrix
                          [measures]="matrixMeasures()"
                          (selectedValues)="onValuesSelected($event)"
                        ></ubt-geods-matrix>
                      </div>
                    </div>

                    <div class="gauges-section">
                      <div class="section-header">{{ this.dataService.res('Ubt-Dashboard-Title-Chart') }}</div>
                      <div class="gauges-scroll">
                        <div class="gauge-card" *ngFor="let measure of gaugeMeasures()">
                          <ubt-measure-gauge
                            [measureName]="measure.Measure_Designation"
                            [score]="measure.TotalScore"
                            [speed]="measure.Effort"
                            [benefit]="measure.Benefit"
                          >
                          </ubt-measure-gauge>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="grid-section">
                    <div class="section-header">{{ this.dataService.res('Ubt-Dashboard-Title-Grid') }}</div>
                    <abc-grid
                      [dataSource]="gridMeasures()"
                      [showBorders]="false"
                      [rowAlternationEnabled]="true"
                      [showColumnLines]="false"
                      [height]="240"
                      [columnAutoWidth]="true"
                    >
                      <dxo-scrolling mode="virtual"></dxo-scrolling>
                      <dxo-paging [enabled]="false"></dxo-paging>
                      <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                      <dxo-header-filter [visible]="true"></dxo-header-filter>
                      <dxi-column
                        dataField="Measure_Designation"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Name') }}"
                        [minWidth]="200"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="progressDirection"
                        caption=""
                        [width]="60"
                        alignment="center"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="progressPercentage"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Progress') }}"
                        [width]="200"
                        alignment="center"
                        [allowHeaderFiltering]="false"
                        [calculateSortValue]="calculateProgressSort" 
                      ></dxi-column>
                      <dxi-column
                        dataField="maturityLevel"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-HG') }}"
                        [width]="60"
                        alignment="center"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="TotalScore"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Total-Score') }}"
                        sortOrder="desc"
                        [width]="200"
                        alignment="center"
                        [calculateFilterExpression]="calculateTotalScoreFilterExpression"
                      >
                        <dxo-header-filter [dataSource]="totalScoreFilterDataSource"></dxo-header-filter>
                      </dxi-column>
                      <dxi-column
                        dataField="Effort"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Speed') }}"
                        [width]="150"
                        alignment="center"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="Benefit"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Benefit') }}"
                        [width]="80"
                        alignment="center"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="Impact"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Impact') }}"
                        [width]="120"
                        alignment="right"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                      <dxi-column
                        dataField="Cost"
                        caption="{{ dataService.res('Ubt-Dashboard-Column-Cost') }}"
                        [width]="120"
                        alignment="right"
                        [allowHeaderFiltering]="false"
                      ></dxi-column>
                    </abc-grid>
                  </div>
                </div>
              </ng-container>

              <!-- TAB 2 -->
              <ng-container *ngSwitchCase="2">
                @if (isDashboard) {
                  <abc-dashboard
                    [endPoint]="dashboardEndpoint"
                    [ajaxHeaders]="dashboardAjaxHeader"
                    [initialDashboardId]="dashboardId"
                  >
                  </abc-dashboard>
                } @else {
                  <h2 fxLayout="row" fxLayoutAlign="center end">{{ title }}</h2>
                }
              </ng-container>
            </ng-container>
          </div>
        </dx-tab-panel>
      </div>
    </div>
  </div>
}
